import { React } from "react";
import "../App.css";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";
import { useUserAuth } from "../auth";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const Password = () => {
	const { logOut, user, passwords, deletePassword } = useUserAuth();
	const navigate = useNavigate();
	const handleLogout = async () => {
		try {
			await logOut();
			navigate("/login");
		} catch (error) {
			toast.error(error.message);
		}
	};
	const Delete = (id) => (
		<>
			<p style={{ fontSize: "18px", fontFamily: "Fredoka" }}>Are you sure you want to delete?</p>
			<button style={{ outline: "none", border: "none", borderRadius: "4px", fontFamily: "Fredoka", padding: "6px", background: "#1da1f2", color: "#ffffff" }} onClick={() => deletePassword(id.id)}>
				Delete
			</button>
		</>
	);
	const Logout = () => (
		<>
			<p style={{ fontSize: "18px", color: "var(--clr-txt)", fontFamily: "Fredoka" }}>Are you sure you want to logout {user.displayName}?</p>
			<button style={{ outline: "none", border: "none", borderRadius: "4px", padding: "6px", color: "#ffffff", fontFamily: "Fredoka", background: "#1da1f2" }} onClick={() => handleLogout()}>
				Yes
			</button>
		</>
	);
	let passwordsContent = [];
	for (let i = 0; i < passwords.length; i++) {
		passwordsContent.push(
			<motion.div layout key={passwords[i].id} className="passcard">
				<motion.span initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.1 }} id={passwords[i].id}>
					{passwords[i].sitename}
					<div className="listbtns">
						<Link style={{ marginBottom: "-4px" }} to="/password" state={{ id: passwords[i].id, sitename: passwords[i].sitename, username: passwords[i].username, password: passwords[i].password }}>
							<Icon className="rightIcon" icon="bi:arrow-right-short" />
						</Link>
						<Icon className="delicon" onClick={() => toast(<Delete id={passwords[i].id} name={passwords[i].sitename} />)} icon="ant-design:minus-circle-twotone" />
					</div>
				</motion.span>
			</motion.div>
		);
	}
	return (
		<>
			<input type="checkbox" id="check" />
			<div className="route-icons">
				<Link className="route-icon" to="/passwords">
					<Icon icon="logos:keycdn-icon" />
				</Link>
				<Link className="route-icon" to="/">
					<Icon icon="noto-v1:notebook" />
				</Link>
				<Link className="route-icon" to="/files">
					<Icon icon="vscode-icons:folder-type-images-opened" />
				</Link>
			</div>
			<motion.section initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} transition={{ ease: "linear", duration: 0.08 }} style={{ alignItems: "flex-start", backgroundImage: `url("https://firebasestorage.googleapis.com/v0/b/space-73.appspot.com/o/passwords.svg?alt=media")`, backgroundSize: "600px" }}>
				{user != null && (
					<>
						<span className="logoutIcon">
							<Icon onClick={() => toast(<Logout />)} icon="majesticons:logout-half-circle" />
						</span>
						<span className="generatePasswordBtn">
							<Link to="/password">
								<button style={{ padding: "8px 15px", borderRadius: "6px" }} className="btn">
									Generate Password
								</button>
							</Link>
						</span>
						<div id="passcards-wrapper" style={{ marginTop: "100px", marginBottom: "125px" }} className="passcards-wrapper">
							<div className="passcards">{passwordsContent}</div>
							{passwords.length === 0 && <div className="msgText">Your passwords are completely encrypted and are only visible to you.</div>}
						</div>
					</>
				)}
			</motion.section>
		</>
	);
};

export default Password;
